
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { OrderServiceStage, ViewType } from '@/types/orderServicer';

@Component({
  name: 'orderServicerAll',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE;
  private vt = ViewType.ORDER_SERVICER_ALL;
  private oId:any=''
  created() {
    this.oId = this.$route.query.order_id;
  }
}
